export interface Brand {
  name: string;
  logo: string;
}
export const brands: Brand[] = [
  {
    name: 'Intercom',
    logo: 'intercom.png',
  },
  {
    name: 'PayPal',
    logo: 'paypal.png',
  },
  {
    name: 'Moat',
    logo: 'moat.png',
  },
  {
    name: 'ABTasty',
    logo: 'abtasty.jpg',
  },
  {
    name: 'Advault',
    logo: 'av.png',
  },
  {
    name: 'Drip',
    logo: 'drip.png',
  },
  {
    name: 'Yandex',
    logo: 'yandex.png',
  },
  {
    name: 'Oracle',
    logo: 'oracle.png',
  },
  {
    name: 'Mozilla',
    logo: 'mozilla.png',
  },
  {
    name: 'Stripe',
    logo: 'stripe.png',
  },
  // {
  //   name: 'Braze',
  //   logo: 'braze.png',
  // },
  {
    name: 'ExpertSender',
    logo: 'expertsender.png',
  },
  {
    name: 'Experian',
    logo: 'experian.png',
  },
  {
    name: 'SmarterClick',
    logo: 'smarterclick.png',
  },
  {
    name: 'eBay',
    logo: 'ebay.png',
  },
  {
    name: 'YieldKit',
    logo: 'yieldkit.png',
  },
  {
    name: 'RevBoss',
    logo: 'revboss.png',
  },
  {
    name: 'Direct',
    logo: 'getdirect.png',
  },
  {
    name: 'BuySellAds',
    logo: 'bsa.png',
  },
  {
    name: 'Convert',
    logo: 'convert.png',
  },
  {
    name: 'Rented',
    logo: 'rented.png',
  },
  {
    name: 'Olapic',
    logo: 'olapic.png',
  },
  {
    name: 'ZipRecruiter',
    logo: 'ziprecruiter.png',
  },
  {
    name: 'Blackbaud',
    logo: 'blackbaud.png',
  },
  {
    name: 'Matcha',
    logo: 'matcha.png',
  },
];
